import { ReactNode } from "react";
import { useLocation, Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

/** Client-only paths: founder navigating here gets redirected to /admin */
const CLIENT_ONLY_PATHS = [
  "/",
  "/inventory",
  "/sales",
  "/manual-entry",
  "/expenses",
  "/master-ledger",
  "/suppliers",
  "/transport-logistics",
  "/reports",
  "/my-activity",
  "/locations",
  "/system-logs",
  "/team",
];

export function FounderClientRedirect({ children }: { children: ReactNode }) {
  const { isFounder } = useAuth();
  const { pathname } = useLocation();

  if (isFounder && CLIENT_ONLY_PATHS.includes(pathname)) {
    return <Navigate to="/admin" replace />;
  }
  return <>{children}</>;
}
